import { AsyncAPIDefinition, OpenAPI2Definition, OpenAPI3Definition } from '~/portal/types/api.definitions'
import { API_FILE_TYPES } from '~/portal/types/downloadApi'
import { downloadApi } from '~/portal/utils/shared/downloadApi'

export const DownloadApiLink = ({
  label,
  title,
  format,
  definition,
}: {
  label: string,
  title?: string,
  format: API_FILE_TYPES,
  definition: OpenAPI2Definition | OpenAPI3Definition | AsyncAPIDefinition,
}) => (
  <button
    className="block w-full text-left px-4 py-1.5"
    onClick={() => downloadApi(format, definition, title || 'api')}
  >
    {label}
  </button>
)
